import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleAchievementType extends Cloneable {
    static NONE = new SmartOfferBundleAchievementType(0, "NONE");
    static PIGGY = new SmartOfferBundleAchievementType(1, "PIGGY");
    //static MARKET = new SmartOfferBundleAchievementType(2, "MARKET");
    static SEASON = new SmartOfferBundleAchievementType(3, "SEASON");
    static BATTLE_PASS = new SmartOfferBundleAchievementType(4, "BATTLE_PASS");
    static MAIN_QUESTS = new SmartOfferBundleAchievementType(5, "MAIN_QUESTS");
    static TRH_PROGRESS = new SmartOfferBundleAchievementType(6, "TRH_PROGRESS");
    static DAILY_QUESTS = new SmartOfferBundleAchievementType(7, "DAILY_QUESTS");
    static MAIN_QUESTS_V2 = new SmartOfferBundleAchievementType(8, "MAIN_QUESTS_V2");


    static _values = [
        this.PIGGY,
        //this.MARKET,
        this.SEASON,
        this.BATTLE_PASS,
        this.MAIN_QUESTS,
        this.TRH_PROGRESS,
        this.DAILY_QUESTS,
        this.MAIN_QUESTS_V2
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleAchievementType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleAchievementType) {
            return SmartOfferBundleAchievementType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleAchievementType.NONE.equal(value);
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleAchievementType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAchievementType());
        } else if (target instanceof SmartOfferBundleAchievementType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAchievementType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});